import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import {
  getPassportCollectionDetail,
  type PassportCollectionDefinition,
} from '../../services/api/passport';
import PassportCollectionsPage from '../passport/PassportCollectionsPage';
import PassportChrome from '../passport/PassportChrome';
import Button from '../ui/Button';
export function OfficialSetPage() {
  const [params] = useSearchParams();
  const slug = params.get('set');
  return slug ? <OfficialSetDetail key={slug} slug={slug} /> : <PassportCollectionsPage />;
}
function OfficialSetDetail({ slug }: { slug: string }) {
  const [detail, setDetail] = useState<PassportCollectionDefinition | null>(null);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let current = true;
    setError('');
    void getPassportCollectionDetail(slug)
      .then((data) => {
        if (current) setDetail(data);
      })
      .catch((e) => {
        if (current) setError(e instanceof Error ? e.message : 'Set unavailable');
      });
    return () => {
      current = false;
    };
  }, [slug, retry]);
  return (
    <PassportChrome active="collections">
      <div className="space-y-5 max-w-2xl">
        {error && (
          <p role="alert">
            {error} <Button onClick={() => setRetry((r) => r + 1)}>Retry</Button>
          </p>
        )}
        {detail ? (
          <>
            <p className="text-sm text-amber-200">Official encounter set</p>
            <h1 className="text-3xl font-semibold">{detail.title}</h1>
            <p className="text-zinc-400">{detail.description || detail.subtitle}</p>
            <p>
              {detail.progress
                ? `${detail.progress.percent_complete}% complete`
                : 'Sign in to see your progress'}
            </p>
            <ul className="space-y-3">
              {detail.requirements?.map((requirement, index) => (
                <li
                  key={requirement.requirement_key || index}
                  className="rounded-xl border border-white/10 p-4"
                >
                  <span>
                    {requirement.hidden
                      ? 'Hidden requirement'
                      : requirement.title || requirement.requirement_key?.replace(/_/g, ' ')}
                  </span>
                  <span className="block mt-1 text-sm text-zinc-400">
                    {requirement.hidden
                      ? 'Revealed by the organizer'
                      : requirement.satisfied
                        ? 'Collected'
                        : 'Still to find'}
                  </span>
                  {requirement.description && (
                    <p className="mt-1 text-sm">{requirement.description}</p>
                  )}
                </li>
              ))}
            </ul>
            <p className="text-sm text-zinc-400">
              Progress uses eligible verified encounters for the current published version. Photo
              spots do not grant official rewards. Revoked encounters no longer fill a slot;
              historical awards remain in your record.
            </p>
            <Link className="btn-secondary" to="/events">
              Find events
            </Link>
          </>
        ) : (
          !error && <p role="status">Loading set…</p>
        )}
        <Link className="block py-3 text-amber-200 underline" to="/passport/sets">
          All sets
        </Link>
      </div>
    </PassportChrome>
  );
}
